import { render, staticRenderFns } from "./DisasterEvent.vue?vue&type=template&id=747c00e0&scoped=true"
import script from "./DisasterEvent.vue?vue&type=script&lang=js"
export * from "./DisasterEvent.vue?vue&type=script&lang=js"
import style0 from "./DisasterEvent.vue?vue&type=style&index=0&id=747c00e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "747c00e0",
  null
  
)

export default component.exports